import logo from "./logo.svg";
import david from "./images/david.png";
import "./App.css";
import wave from "./images/200.gif";
import dick from "./images/dick.png";
import brain from "./images/brain.png";
import ankle from "./images/ankle1.png";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { useState } from "react";
import Scan from "./Scan";
import EggAudio from "./Eggboy_v3.mp3";

function Home(props) {
  function changeBackground(x) {
    if (x === 1) {
      props.setC1Pic(wave);
      props.i++;
      props.setPoemStep(props.poem[props.i]);
      props.setImageStep(brain);
      props.setImgClass("brain");
    } else if (x === 2) {
      props.setC2Pic(wave);
      props.i++;
      props.setPoemStep(props.poem[props.i]);
      props.setImageStep(dick);
      props.setImgClass("dick");
    } else {
      props.setC3Pic(wave);
      props.i++;
      props.setPoemStep(props.poem[props.i]);
      props.setImageStep(ankle);
      props.setImgClass("ankle");
    }
  }

  return (
    <div className="App">
      <div className="davidDiv">
        <Link to="/scan">
          <div className="circle1" onClick={() => changeBackground(1)}>
            <img src={props.c1Pic}></img>
          </div>
        </Link>
        <Link to="scan">
          <div className="circle2" onClick={() => changeBackground(2)}>
            <img src={props.c2Pic}></img>
          </div>
        </Link>
        <Link to="scan">
          <div className="circle3" onClick={() => changeBackground(3)}>
            <img src={props.c3Pic}></img>
          </div>
        </Link>

        <img src={david}></img>
      </div>

      <button onClick={() => console.log(props.poemStep)}>Click</button>
    </div>
  );
}

export default Home;
